/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "../../assets/style/Home.css";
import Aside from "../Aside/Aside";
import Accueil from "./Accueil";
import Apropos from "../Apropos/Apropos";
import Qualification from "../Qualification/Qualification";
import Skills from "../Skills/Skills";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";

export default function Home() {
  return (
    <div className="container">
      <Aside />
      <main className="main">
        <Accueil />
        <Apropos />
        <Qualification />
        <Skills />
        <Contact />
        <Footer />
      </main>
    </div>
  );
}
